module.exports = __webpack_public_path__ + "img/b52.0e50623c.jpg";